import React from "react";
import { Content } from "./Content";
import SafeSiteImage from "./SafeSiteImage";
import Grid from "./Grid";
import styled, { css } from "styled-components";

const ImageStyles = styled.div`
  ${({ ...props }) => css`
    img {
      width: 100%
    }
  `}
`;

export const ContentAndImage = ({ content, image, placement }) => {
  return (
    <Grid columnGap="loose" reverse={placement === "imageOnLeft"}>
      <Grid item md="6" columnGap="loose">
        <Content content={content} />
      </Grid>
      <Grid item md="6" columnGap="loose">
        <ImageStyles>
          <SafeSiteImage image={image.mediaItemUrl} alt={image.altText} />
        </ImageStyles>
      </Grid>
    </Grid>
  );
};
